import { MenuItem, Select } from '@mui/material';
import { DocumentCode } from '@tap/data-providers';

/*
*   Выпадающий список с типами заявок
*/

export type IssueDocumentCode = Extract<DocumentCode, DocumentCode.QC | DocumentCode.UGM | DocumentCode.TOOL | DocumentCode.WIP | DocumentCode.TECH>;

export const IssueDocumentCode = {
    [DocumentCode.QC]: DocumentCode.QC,
    [DocumentCode.UGM]: DocumentCode.UGM,
    [DocumentCode.TOOL]: DocumentCode.TOOL,
    [DocumentCode.WIP]: DocumentCode.WIP,
    [DocumentCode.TECH]: DocumentCode.TECH,
} as const;

type DocumentCodeSpec = {
    name: string,
    code: string,
}

export const IssueTypeSpec: { [key in IssueDocumentCode]: Omit<DocumentCodeSpec, 'code'> } = {
    [IssueDocumentCode.QC]: { name: 'Контроль качества' },
    [IssueDocumentCode.TOOL]: { name: 'Инструменты и СТО' },
    [IssueDocumentCode.UGM]: { name: 'Управление оборудованием' },
    [IssueDocumentCode.WIP]: { name: 'НЗП и готовые материалы' },
    [IssueDocumentCode.TECH]: { name: 'Технология' },
}

const IssueTypeList: DocumentCodeSpec[] = Object.keys(IssueTypeSpec).map(code => ({
    ...IssueTypeSpec[code as keyof typeof IssueTypeSpec],
    code: code as IssueDocumentCode,
}));

type IssueTypeSelectProps = {
    selectedType: IssueDocumentCode,
    handleSelectedTypeChange: (periodType: IssueDocumentCode) => void,
}

export default function IssueTypeSelect({ selectedType, handleSelectedTypeChange }: IssueTypeSelectProps) {

    return (
        <Select
            sx={{ width: '20%' }}
            size='small'
            defaultValue={IssueDocumentCode.QC}
            value={selectedType}
            onChange={(event) => handleSelectedTypeChange(event.target.value as IssueDocumentCode)}
        >
            {IssueTypeList.map((el) =>
                <MenuItem
                    key={el.code}
                    value={el.code}
                >
                    {el.name}
                </MenuItem >,
            )}
        </Select>
    );
}
